import { doc, deleteDoc, updateDoc } from 'firebase/firestore'
import { db } from '../firebase'

const requestRef = (uid, requestId) => doc(db, 'users', uid, 'requests', requestId)

const deleteRequest = {
  soft: (requestId, status, uid) =>
    updateDoc(requestRef(uid, requestId), { status }),

  hard: (requestId, uid) =>
    deleteDoc(requestRef(uid, requestId)),
}

export default deleteRequest
